 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CpvCreditCard',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#cpvcreditcard-credit_card_type_id').on('change', function change(e) {
			var card_type    = $(this).val(),
				$branch_type = $("#cpvcreditcard-credit_card_type_branch_id");

			if (card_type === '1') {
				$branch_type.removeClass('hidden').find('input').prop('disabled', false);
				$branch_type.closest('.form-group').removeClass('hidden');
			} else {
				$branch_type.addClass('hidden').find('input').prop('disabled', true);
				$branch_type.closest('.form-group').addClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
